import { OTHER_VALUE } from "./CoachProfile/CoachProfileSettings";

export const INDEX_TO_DAY = [
  "SUNDAY", // 0
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];

export const DAY_NAMES = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const AVAILABILITY_TYPE = {
  RECURRING: "recurring",
  // NON_RECURRING: "non-recurring",
};

export const CERTIFICATE = {
  ACC: "ACC",
  PCC: "PCC",
  MCC: "MCC",
  MBTI: "MBTI",
  GALLUP_STRENGTHSFINDER: "GALLUP_STRENGTHSFINDER",
  DISC: "DISC",
  HOGAN: "HOGAN",
  LPI: "LPI",
  FEEDBACK_360: "FEEDBACK_360",
  SHL: "SHL",
  INSIGHTS_DISCOVERY: "INSIGHTS_DISCOVERY",
  OTHER: OTHER_VALUE,
};

export const TRAVEL_WILLINGNESS = {
  NO: "NO",
  WITHIN_CITY: "WITHIN_CITY",
  WITHIN_COUNTRY: "WITHIN_COUNTRY",
  WITHIN_REGION: "WITHIN_REGION",
  WITHIN_EUROPE: "WITHIN_EUROPE",
  GLOBALLY: "GLOBALLY",
  OTHER: OTHER_VALUE,
};

export const DELIVERY_FORMAT = {
  ONLINE: "ONLINE",
  ONSITE: "ONSITE",
  HYBRID: "HYBRID",
  OTHER: OTHER_VALUE,
};

export const SERVICE_TYPE = {
  ONE_TO_ONE: "ONE_TO_ONE",
  EXECUTIVE: "EXECUTIVE",
  TEAM: "TEAM",
  CAREER: "CAREER",
  GROUP: "GROUP",
  PEER_MENTORING: "PEER_MENTORING",
  WORKSHOPS: "WORKSHOPS",
  LONGER_PROGRAMS: "LONGER_PROGRAMS",
  OTHER: OTHER_VALUE,
};

export const PRIMARY_ROLE = {
  COACH: "COACH",
  MENTOR: "MENTOR",
  TRAINER: "TRAINER",
  FACILITATOR: "FACILITATOR",
  CONSULTANT: "CONSULTANT",
  SPEAKER: "SPEAKER",
};

// TODO
export const TOPIC = {
  AI_ADOPTION_FOR_LEADERS: "AI_ADOPTION_FOR_LEADERS",
  AI_GOVERNANCE_AND_ETHICS: "AI_GOVERNANCE_AND_ETHICS",
  BUSINESS: "BUSINESS",
  CAREER: "CAREER",
  CHANGE: "CHANGE",
  COACHING_SKILLS_FOR_MANAGERS: "COACHING_SKILLS_FOR_MANAGERS",
  COMMUNICATION: "COMMUNICATION",
  CONFIDENCE: "CONFIDENCE",
  CONFLICT: "CONFLICT",
  CROSS_CULTURAL_LEADERSHIP: "CROSS_CULTURAL_LEADERSHIP",
  CULTURAL_DIFFERENCES: "CULTURAL_DIFFERENCES",
  DECISION_MAKING: "DECISION_MAKING",
  DELEGATION: "DELEGATION",
  DIVERSITY: "DIVERSITY",
  EMOTIONAL_INTELLIGENCE: "EMOTIONAL_INTELLIGENCE",
  ENTREPRENEURSHIP: "ENTREPRENEURSHIP",
  EXECUTIVE: "EXECUTIVE",
  FACILITATION: "FACILITATION",
  FEEDBACK_CULTURE: "FEEDBACK_CULTURE",
  FITNESS: "FITNESS",
  HEALTH: "HEALTH",
  IMPOSTER_SYNDROME: "IMPOSTER_SYNDROME",
  INFLUENCING_SKILLS: "INFLUENCING_SKILLS",
  INNOVATION_AND_CREATIVITY: "INNOVATION_AND_CREATIVITY",
  LEADERSHIP: "LEADERSHIP",
  LEADING_WITHOUT_AUTHORITY: "LEADING_WITHOUT_AUTHORITY",
  LIFE: "LIFE",
  MANAGEMENT: "MANAGEMENT",
  MENTAL_FITNESS: "MENTAL_FITNESS",
  MENTORSHIP: "MENTORSHIP",
  NEGOTIATIONS: "NEGOTIATIONS",
  ORGANIZATIONAL_DEVELOPMENT: "ORGANIZATIONAL_DEVELOPMENT",
  PERFORMANCE: "PERFORMANCE",
  PSYCHOLOGICAL_SAFETY: "PSYCHOLOGICAL_SAFETY",
  RELATIONSHIPS: "RELATIONSHIPS",
  REMOTE_LEADERSHIP: "REMOTE_LEADERSHIP",
  RESILIENCE: "RESILIENCE",
  SALES: "SALES",
  SELF_CRITICISM: "SELF_CRITICISM",
  SELF_LEADERSHIP: "SELF_LEADERSHIP",
  STRATEGIC_THINKING: "STRATEGIC_THINKING",
  STRESS_MANAGEMENT: "STRESS_MANAGEMENT",
  TEAMS: "TEAMS",
  TIME_MANAGEMENT: "TIME_MANAGEMENT",
  TRANSFORMATIONS: "TRANSFORMATIONS",
  WELLBEING: "WELLBEING",
  WOMEN: "WOMEN",
  OTHER: OTHER_VALUE,
};

export const DIAGNOSTIC_TOOL = {
  MBTI: "MBTI",
  GALLUP_STRENGTHSFINDER: "GALLUP_STRENGTHSFINDER",
  DISC: "DISC",
  HOGAN: "HOGAN",
  LPI: "LPI",
  FEEDBACK_360: "FEEDBACK_360",
  SHL: "SHL",
  INSIGHTS_DISCOVERY: "INSIGHTS_DISCOVERY",
  OTHER: OTHER_VALUE,
};

export const INDUSTRY_EXPERIENCE = {
  TECH: "TECH",
  FINANCE: "FINANCE",
  PHARMA: "PHARMA",
  RETAIL: "RETAIL",
  MANUFACTURING: "MANUFACTURING",
  LOGISTICS: "LOGISTICS",
  TELECOMMUNICATIONS: "TELECOMMUNICATIONS",
  PUBLIC_SECTOR: "PUBLIC_SECTOR",
  GENERAL_CROSS_INDUSTRY: "GENERAL_CROSS_INDUSTRY",
  OTHER: OTHER_VALUE,
};
